import { useMutation } from '@tanstack/react-query';
import { supabase } from '../../api';

const cancelBooking = async (id, reason) => {
    const { data: updateData, error: updateError } = await supabase
        .from('booking_transactions')
        .update({ status: "Canceled", cancellation_reason: reason, record_id: null })
        .eq('id', id)

    if (updateError) {
        throw new Error(updateError.message);
    }

    return updateData;
};

export default function useCancelBooking(id, reason) {
    return useMutation(({ id, reason }: { id, reason }) => cancelBooking(id, reason), {
        onSuccess: async (data) => data,
    });
}
